/**
 * Converts an object into an array of key-value tuples, where values are converted to strings.
 * If a value is an array, it creates multiple tuples with the same key for each array item.
 *
 * @param {Record<string, unknown | unknown[]>} obj - The input object to convert
 * @returns {[string, string][]} An array of tuples, where each tuple contains a key and its value as strings
 *
 * @example
 * const input = {
 *   name: "John",
 *   age: 30,
 *   hobbies: ["reading", "gaming"]
 * };
 * const result = objectToTuples(input);
 * // result = [
 * //   ["name", "John"],
 * //   ["age", "30"],
 * //   ["hobbies", "reading"],
 * //   ["hobbies", "gaming"]
 * // ]
 */

export default function objectToTuples(
	obj: Record<string, unknown | unknown[]>,
): [string, string][] {
	const result: [string, string][] = [];

	for (const [key, value] of Object.entries(obj)) {
		if (Array.isArray(value)) {
			for (const item of value) {
				result.push([key, `${item}`]);
			}
		} else {
			result.push([key, `${value}`]);
		}
	}
	return result;
}
